if (!customElements.get('guided-selling')) {
  customElements.define(
    'guided-selling',
    class GuidedSelling extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this);
        this.addEventListener('auxclick', this);
      }

      handleEvent(event) {
        // auxclick covers middle-click "open in new tab"; ignore the right button.
        if (event.type === 'auxclick' && event.button !== 1) return;

        const link = event.target.closest('[data-guided-selling-card]');
        const cardName = link?.dataset.guidedSellingCard;
        if (!cardName) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'guided_selling_click', card_name: cardName });
      }
    }
  );
}
